import React from "react";
import { FcCloseUpMode } from "react-icons/fc";

const MachineCountInBlock = ({ data }) => {
  const filData = data.filter((o) => o.Availed !== "00:00:00");
  const tableData = Object.values(
    filData.reduce((acc, { Block_Type }) => {
      const key = Block_Type?.trim();
      if (!key) return acc;
      acc[key] = acc[key] || { blocktype: key, count: 0 };
      acc[key].count++;
      return acc;
    }, {})
  ).sort((a, b) => b.count - a.count);

  return (
    <div className="papaDiv">
      {(data && data.length > 0) || <div>No Data Found</div>}
      {data && data.length > 0 && (
        <div>
          <h5 className="mb-1 p-1 text-white bg-dark">
            Block Type And Count Report
          </h5>
          <div
            className="table-responsive "
            style={{ maxHeight: "350px", overflow: "auto" }}
          >
            <table className="table  table-striped table-hover">
              <thead
                className="sticky-top table-dark m-0 p-0"
                style={{ zIndex: 1 }}
              >
                <tr>
                  <th>SNo</th>
                  <th className="text-wrap">BLOCK TYPE </th>
                  <th>COUNT</th>
                </tr>
              </thead>

              <tbody>
                {tableData.map((obj, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{ind + 1}</td>
                      <td className="text-wrap">{obj.blocktype}</td>
                      <td>{obj.count}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineCountInBlock;
